import React, { useState } from 'react';
import { deleteSaved, updateSaved } from './storage.js';
import { GAN_WX } from './tables.js';

const WX_COLOR = { 木: '#2e7d32', 火: '#c62828', 土: '#9c6b3f', 金: '#607d8b', 水: '#1565c0' };
const WX_ORDER = ['木', '火', '土', '金', '水'];

function Pillars({ rec, big }) {
  return (
    <span className={`sv-pillars${big ? ' big' : ''}`}>
      {rec.pillars.map((p, i) => (
        <i key={i}>
          <b style={{ color: WX_COLOR[GAN_WX[p.gan]] }}>{p.gan}</b>
          <b>{p.zhi}</b>
        </i>
      ))}
    </span>
  );
}

/** 行内展开的预览块 */
function PreviewBlock({ rec }) {
  const shenSha = (rec.shenShaNames || []).slice(0, 8);
  return (
    <div className="sv-preview">
      <div className="cmp-pillars">
        {rec.pillars.map((p, i) => (
          <span key={i} className="cmp-p">
            <small>{['年', '月', '日', '时'][i]}柱</small>
            <b>{p.gan}</b><b>{p.zhi}</b>
          </span>
        ))}
      </div>
      <dl className="sv-facts">
        <dt>五行</dt><dd>{WX_ORDER.map(w => `${w}${rec.wuxingCount[w]}`).join(' · ')}{rec.missing.length ? `（缺 ${rec.missing.join('、')}）` : ''}</dd>
        <dt>日主</dt><dd>{rec.dayGan}{rec.gender ? ` · ${rec.gender}命` : ''}</dd>
        {shenSha.length > 0 && <><dt>神煞</dt><dd>{shenSha.join('、')}{(rec.shenShaNames || []).length > 8 ? ' 等' : ''}</dd></>}
        {rec.note && <><dt>备注</dt><dd>{rec.note}</dd></>}
      </dl>
      <p className="bz-tip">完整盘面请点「载入」查看；此预览为存档快照。</p>
    </div>
  );
}

/** 行内编辑表单 */
function EditForm({ rec, onDone }) {
  const [name, setName] = useState(rec.name || '');
  const [gender, setGender] = useState(rec.gender || '男');
  const [note, setNote] = useState(rec.note || '');
  return (
    <div className="sv-edit">
      <label>姓名<input value={name} onChange={e => setName(e.target.value)} placeholder="如：本人" maxLength={30} /></label>
      <label>性别
        <select value={gender} onChange={e => setGender(e.target.value)}>
          <option value="男">男</option><option value="女">女</option>
        </select>
      </label>
      <label className="grow">备注<input value={note} onChange={e => setNote(e.target.value)} placeholder="如：本人 / 客户A / 朋友介绍" maxLength={120} /></label>
      <button type="button" className="btn primary sm" onClick={() => { onDone(updateSaved(rec.id, { name, gender, note })); }}>保存</button>
      <button type="button" className="btn ghost sm" onClick={() => onDone(null)}>取消</button>
    </div>
  );
}

export default function SavedList({ list, setList, current, onLoad }) {
  const [open, setOpen] = useState(false);          // 面板展开/收起
  const [previewId, setPreviewId] = useState(null); // 预览展开的行
  const [editId, setEditId] = useState(null);       // 编辑中的行
  const [picked, setPicked] = useState([]);         // 对比选择（最多两个）

  const togglePick = (id) => {
    setPicked(p => p.includes(id) ? p.filter(x => x !== id) : [...p.slice(-1), id]);
  };
  const doDelete = (id) => {
    if (picked.includes(id)) setPicked(p => p.filter(x => x !== id));
    if (previewId === id) setPreviewId(null);
    if (editId === id) setEditId(null);
    setList(deleteSaved(id));
  };
  const doneEdit = (newList) => { setEditId(null); if (newList) setList(newList); };

  const pickedRecs = list.filter(r => picked.includes(r.id));
  let compareNote = null;
  if (pickedRecs.length === 2) {
    const [A, B] = pickedRecs;
    const sameDayGan = A.dayGan === B.dayGan;
    const sameDayPillar = A.pillars[2].gan + A.pillars[2].zhi === B.pillars[2].gan + B.pillars[2].zhi;
    const chongPairs = [['子', '午'], ['丑', '未'], ['寅', '申'], ['卯', '酉'], ['辰', '戌'], ['巳', '亥']];
    const dayChong = chongPairs.some(([x, y]) =>
      (A.pillars[2].zhi === x && B.pillars[2].zhi === y) || (A.pillars[2].zhi === y && B.pillars[2].zhi === x));
    compareNote = (
      <div className="cmp-note">
        <p>日主：{sameDayGan ? `两人同为${A.dayGan}，性情基调相似` : `甲为${A.dayGan}、乙为${B.dayGan}，气质取向不同`}；
           日柱：{sameDayPillar ? '完全相同（缘分感应深）' : '不同'}；{dayChong ? '⚠ 两人日支相冲（子午/丑未等），相处易有起伏，需多包容' : '日支无冲'}。</p>
      </div>
    );
  }

  return (
    <section className={`panel bz-panel bz-saved${open ? ' open' : ''}`}>
      {/* 折叠头：始终显示 */}
      <button type="button" className="sv-toggle" onClick={() => setOpen(o => !o)}
        title={open ? '收起存档列表' : '展开存档列表（可载入 / 预览 / 编辑 / 删除 / 对比）'}>
        <span className="sv-caret">{open ? '▾' : '▸'}</span>
        🗂 已存盘命例
        <b className="sv-count">{list.length}</b>
        <small>本机浏览器保存 · 点右上角「💾 存当前盘」添加</small>
      </button>

      {open && (
        list.length === 0 ? (
          <p className="bz-tip sv-empty">尚无存档。排好盘后点上方「💾 存当前盘」，即可在这里管理与对比。</p>
        ) : (
          <>
            <div className="sv-list">
              {list.map(r => (
                <div key={r.id} className={`sv-item${picked.includes(r.id) ? ' on' : ''}`}>
                  <div className="sv-row">
                    <label className="sv-pick" title="勾选两个存档可进行对比">
                      <input type="checkbox" checked={picked.includes(r.id)} onChange={() => togglePick(r.id)} />
                    </label>
                    <div className="sv-main">
                      <b className="sv-name">{r.name}</b>
                      <small className="sv-meta">{r.gender} · {r.solarText.slice(0, 16)}{r.city && r.city !== '不校正' ? ` · ${r.city}` : ''}</small>
                      <Pillars rec={r} />
                      {r.note && <span className="sv-notetag" title={r.note}>{r.note}</span>}
                    </div>
                    <div className="sv-actions">
                      <button title="把此盘载入到上方排盘" onClick={() => onLoad(r)}>载入</button>
                      <button className={previewId === r.id ? 'act' : ''} onClick={() => setPreviewId(previewId === r.id ? null : r.id)}>预览</button>
                      <button className={editId === r.id ? 'act' : ''} onClick={() => { setEditId(editId === r.id ? null : r.id); setPreviewId(null); }}>编辑</button>
                      <button className="del" title="删除此存档" onClick={() => doDelete(r.id)}>删除</button>
                    </div>
                  </div>
                  {previewId === r.id && <PreviewBlock rec={r} />}
                  {editId === r.id && <EditForm rec={r} onDone={doneEdit} />}
                </div>
              ))}
            </div>

            {pickedRecs.length === 2 && (
              <div className="cmp-wrap">
                <h5>两盘对比</h5>
                <div className="cmp-row">
                  {pickedRecs.map(r => (
                    <div key={r.id} className="cmp-chart">
                      <h5>{r.name} <small>{r.gender} · {r.solarText.slice(0, 10)}</small></h5>
                      <Pillars rec={r} />
                      <small className="cmp-wx">
                        {WX_ORDER.map(w => `${w}${r.wuxingCount[w]}`).join(' ')}
                        {r.missing.length ? ` · 缺${r.missing.join('')}` : ''}
                      </small>
                    </div>
                  ))}
                </div>
                {compareNote}
                <p className="bz-tip">五行统计按天干4字＋地支本气4字计。</p>
              </div>
            )}
          </>
        )
      )}
    </section>
  );
}
